import { FieldDefinition, FieldBuilder, MenuCategories, MenuSubcategories, MENU_CATEGORY_KEY, MENU_SUBCATEGORY_KEY, MENU_NAME_SUFFIX } from '@zendra/shared';
import { SuperiorClasificationService } from '../proxy/planning/controllers/superior-clasification.service';
import { GenderService } from '../proxy/planning/controllers/gender.service';

FieldBuilder.setNamespace('Planning');

export const SPECIEFAMILY_FIELDS: FieldDefinition[] = [
  FieldBuilder
    .text('name', 'Entity.SpecieFamily.Name')
    .required()
    .minLength(1)
    .maxLength(100)
    .build(),
  FieldBuilder
    .text('code', 'Entity.SpecieFamily.Code')
    .required()
    .minLength(1)
    .maxLength(10)
    .build(),
  FieldBuilder
    .foreignKey('superiorClasificationId', 'Entity.SuperiorClasification', SuperiorClasificationService)
    .required()
    .displayFromNested('superiorClasification.name')
    .sortBy('superiorClasification.name')
    .build(),
  FieldBuilder
   .foreignKey('genderId', 'Entity.Gender', GenderService)
   .required()
   .displayFromNested('gender.name') 
   .sortBy('gender.name')   
   .build(),
];

export const SPECIEFAMILY_CONFIG = {
  entityName: 'SpecieFamily',
  localizationKey: 'Planning::Entity.SpecieFamily',
  fields: SPECIEFAMILY_FIELDS,
  permission: 'PlanningEnvironment.SpecieFamilies',
  showInMenu: true,
  menuCategory: MENU_CATEGORY_KEY + MenuCategories.Planning + MENU_NAME_SUFFIX,
  menuSubcategory: MENU_SUBCATEGORY_KEY + MenuSubcategories.Environment + MENU_NAME_SUFFIX,
};
